export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
          <div className="lg:col-span-6">
            <p className="text-xs text-primary-600 font-medium tracking-widest uppercase">ABOUT US</p>
            <h2 className="mt-1 text-2xl md:text-3xl text-foreground-950 leading-tight">
              关于呱呱爆料
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              呱呱爆料是一档专注娱乐圈与大众文化热点的吃瓜资讯平台。我们不满足于停留在标题表面，而是把每一条内部流出、首发曝光与绝密文件，尽可能还原成一段有时间、有细节、有来龙去脉的完整叙事。
            </p>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
              我们相信，围观八卦也是一种认真的事。面对漫天传闻，我们坚持先核对再跟进、先脱敏再发布的原则，让每一位读者都能在追求真相的同时，保持清醒与体面。
            </p>
            <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
              <li className="flex items-start gap-2.5 rounded-lg bg-background-50 p-4">
                <span className="inline-flex w-8 h-8 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700 text-base"><i className="ri-eye-line" /></span>
                <div>
                  <p className="text-foreground-950 font-medium">先核对，再跟进</p>
                  <p className="text-xs text-foreground-600 mt-1 leading-relaxed">多元信息源交叉比对，标注确认程度。</p>
                </div>
              </li>
              <li className="flex items-start gap-2.5 rounded-lg bg-background-50 p-4">
                <span className="inline-flex w-8 h-8 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-800 text-base"><i className="ri-shield-user-line" /></span>
                <div>
                  <p className="text-foreground-950 font-medium">脱敏再发布</p>
                  <p className="text-xs text-foreground-600 mt-1 leading-relaxed">涉及隐私的细节一律模糊，守住底线。</p>
                </div>
              </li>
              <li className="flex items-start gap-2.5 rounded-lg bg-background-50 p-4">
                <span className="inline-flex w-8 h-8 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-900 text-base"><i className="ri-compass-3-line" /></span>
                <div>
                  <p className="text-foreground-950 font-medium">完整叙事</p>
                  <p className="text-xs text-foreground-600 mt-1 leading-relaxed">还原来龙去脉，而不是碎片化搬运。</p>
                </div>
              </li>
              <li className="flex items-start gap-2.5 rounded-lg bg-background-50 p-4">
                <span className="inline-flex w-8 h-8 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700 text-base"><i className="ri-heart-3-line" /></span>
                <div>
                  <p className="text-foreground-950 font-medium">理性吃瓜</p>
                  <p className="text-xs text-foreground-600 mt-1 leading-relaxed">不造谣、不传谣，做清醒的围观者。</p>
                </div>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-6">
            <div className="rounded-xl bg-foreground-950 text-background-50 p-6 md:p-8">
              <p className="text-sm tracking-widest uppercase text-accent-400">BRAND VOICE</p>
              <blockquote className="mt-4 text-lg md:text-xl leading-relaxed text-background-100" style={{ fontFamily: "var(--font-heading)" }}>
                “一手消息，先人一步。我们把每一份物料当成一块拼图，陪你把娱乐世界看得更清楚。”
              </blockquote>
              <div className="mt-6 grid grid-cols-3 gap-3 text-center">
                <div className="rounded-lg bg-foreground-900 py-4">
                  <p className="text-2xl text-accent-400" style={{ fontFamily: "var(--font-heading)" }}>吃瓜</p>
                  <p className="text-xs text-background-100/60 mt-1">认真对待</p>
                </div>
                <div className="rounded-lg bg-foreground-900 py-4">
                  <p className="text-2xl text-accent-400" style={{ fontFamily: "var(--font-heading)" }}>核瓜</p>
                  <p className="text-xs text-background-100/60 mt-1">交叉验证</p>
                </div>
                <div className="rounded-lg bg-foreground-900 py-4">
                  <p className="text-2xl text-accent-400" style={{ fontFamily: "var(--font-heading)" }}>清瓜</p>
                  <p className="text-xs text-background-100/60 mt-1">理性表达</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}